// client/src/components/common/NotFound.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Paper,
  Box,
  Button
} from '@mui/material';
import { ErrorOutline as ErrorIcon, Home as HomeIcon } from '@mui/icons-material';

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 8 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          mb: 3
        }}>
          <ErrorIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
          <Typography variant="h1" sx={{ mb: 2, fontSize: '5rem' }}>
            404
          </Typography>
          <Typography variant="h4" gutterBottom>
            {t('pageNotFound')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('pageNotFoundMessage')}
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<HomeIcon />}
          onClick={() => navigate('/')}
        >
          {t('backToDashboard')}
        </Button>
      </Paper>
    </Container>
  );
};

export default NotFound;